/**
 * Interactions API клиент (TODO-065)
 * Дата: 14.02.2026
 */
import { apiClient } from './client';
import type {
  InteractionEvent,
  InteractionEventSummary,
  InteractionFilters,
  InteractionListResponse,
  InteractionSummaryResponse,
} from '@/types/interaction';

export type { InteractionEvent, InteractionEventSummary };

export const interactionsApi = {
  async list(params: Partial<InteractionFilters>): Promise<InteractionListResponse> {
    const { data } = await apiClient.get('/interactions', { params });
    return data;
  },

  async summary(tenantId: string, dateFrom?: string, dateTo?: string): Promise<InteractionSummaryResponse> {
    const { data } = await apiClient.get('/interactions/summary', {
      params: { tenant_id: tenantId, date_from: dateFrom, date_to: dateTo },
    });
    return data;
  },

  async getById(id: string): Promise<InteractionEvent> {
    const { data } = await apiClient.get(`/interactions/${id}`);
    return data;
  },

  async updateStatus(id: string, status: string): Promise<InteractionEvent> {
    const { data } = await apiClient.patch(`/interactions/${id}`, { status });
    return data;
  },
};
